module.exports = __webpack_public_path__ + "static/media/search-dollar.04ffda57.svg";